import { Component, inject, OnInit, signal } from '@angular/core';
import { NotificationController, NotificationEntity } from '@domain';
import { TranslatePipe } from '@ngx-translate/core';
import { RaEmptyComponent } from 'src/app/shared/components/ra-empty/ra-empty.component';
import { RaLoadingComponent } from 'src/app/shared/components/ra-loading/ra-loading.component';
import { NotificationReadStatus } from 'src/app/domain/controllers/notification.controller';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';

@Component({
    selector: 'notification-list',
    templateUrl: 'notification-list.component.html',
    styleUrl: 'notification-list.component.scss',
    imports: [NotificationCardComponent, RaEmptyComponent, RaLoadingComponent, TranslatePipe],
})
export class NotificationListComponent implements OnInit {
    // * [Injects]
    public notificationController = inject(NotificationController);

    // * [State]
    public activeTab = signal<NotificationReadStatus>('unread');

    ngOnInit(): void {
        // Carrega as duas abas ao abrir o dropdown (sem marcar nada como lido).
        this.notificationController.loadUnread(true).subscribe();
        this.notificationController.loadRead(true).subscribe();
    }

    public setTab(tab: NotificationReadStatus): void {
        this.activeTab.set(tab);
    }

    public markAllAsRead(): void {
        this.notificationController.markAllAsRead().subscribe();
    }

    public onCardClick(notification: NotificationEntity): void {
        // Só a aba "Não lidas" marca ao clicar; clicar numa lida não faz nada.
        if (this.activeTab() !== 'unread') return;

        this.notificationController.markAsRead(notification._id).subscribe();
    }

    public loadMore(): void {
        if (this.activeTab() === 'unread') {
            this.notificationController.loadUnread(false).subscribe();
        } else {
            this.notificationController.loadRead(false).subscribe();
        }
    }
}
